import { Tab } from "@mui/material"
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { CustomTabs } from "../../../../components/Forms/CustomTabs"
import UseUrlParam from "../../../../components/Logic/UseUrlProps"
import RessourceMenu from "../../../../components/RessourceMenu"
import TabPanel from "../../../../components/TabPanel"
import { PermissionEnum } from "../../../Permission/PermissionEnum"
import { AbilityContext } from "../../../UserApi/logic/Can"
import { useDeleteOrganisationMutation, useGetOrganisationByIdQuery } from "../../redux/organisationApiSlice"
import { OrganisationDeleteContent } from "./OrganisationDeleteContent"
import InfoTab from "./tabs/InfoTab"

export interface OrganisationInfoDialogProps {
    organisationUuid?: string
    afterDeleteAction?: () => void
}

export const OrganisationInfoDialog = (props: OrganisationInfoDialogProps | UseUrlParam) => {

    const params = useParams();
    const urlPropsUuid = (props as UseUrlParam).shouldGetEntityFromUrl ? params["organisationUuid"] : "";
    const orgPropsUuid = (props as OrganisationInfoDialogProps).organisationUuid

    const organisationUuid = orgPropsUuid ?? urlPropsUuid;

    const [value, setValue] = React.useState(0);
    const [readyForDelete, setReadyForDelete] = React.useState(false);
    const { t } = useTranslation()
OrganisationInfoDialog
    const ability = useContext(AbilityContext);
    const organisationResult = useGetOrganisationByIdQuery(organisationUuid!)

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    if (organisationResult.data == undefined)
        return <></>

    const labels = []
    const tabPanel = []

    labels.push(t("Info") + "")
    tabPanel.push(<TabPanel value={value} index={tabPanel.length}><InfoTab organisationId={organisationResult.data.uuid!} {...props} /></TabPanel>)

    return (
        <>
            <CustomTabs value={value} onChange={handleChange}
                rightMenu={
                    <RessourceMenu
                        isAllowedToDelete={(data) => ability.can(PermissionEnum.GOD, data)}
                        nameOfRessource="organisation"
                        primaryButtonText={t("Organisation") + ": " + organisationResult.data.name}
                        idToFetch={organisationResult.data.uuid}
                        deleteMutation={useDeleteOrganisationMutation}
                        getByIdAction={useGetOrganisationByIdQuery}
                        deleteDialogMaxWidth="lg"
                        deleteButtonContent={readyForDelete ? undefined : <OrganisationDeleteContent organisation={organisationResult.data} setReadyForDelete={setReadyForDelete}/>}
                        afterDeleteAction={(props as OrganisationInfoDialogProps).afterDeleteAction}
                    />
                }>
                {labels.map(label => (<Tab key={label} label={label} />))}
            </CustomTabs>
            {tabPanel.map(tabPanel => tabPanel)}
        </>
    )
}